/**
 * Created by agengmaulana on 4/28/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'

export default class Comment_Reply_Button extends React.Component{

    constructor(props) {
        super(props);

    }

    render(){
        const text = this.props.textreply ? 'Tutup' : 'Balas'
        return(
            <a href="javascript:void(0);" id={'reply-'+this.props.idButton} className={styles.cmt_mr15 +' '+styles.cmt_dk_balas+' '+styles.cmt_href}  onClick={this.props.toggle} >{text}</a>
        )
    }


}



// WEBPACK FOOTER //
// ./static/src/component/comment_reply_button/comment_reply_button.js